angular
    .module("home.directive")
    .directive('equalTo', function () {
        //Check value is equal to other model value
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=equalTo",
                elementLocator: "@elementLocator"
            },
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.equalto = function (modelValue) {
                    if (scope.otherModelValue === undefined) {
                        return $(scope.elementLocator).val() === modelValue;
                    }
                    return modelValue === scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function () {
                    ngModel.$validate();
                }, true);
            }
        };
    })
    .directive('notEqualTo', function () {
        //Check value is not equal to other model value
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=notEqualTo"
            },
            link: function (scope, element, attributes, ngModel) {

                ngModel.$validators.notequalto = function (modelValue) {
                    return modelValue !== scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function () {
                    ngModel.$validate();
                });
            }
        };
    })
    .directive('validPassword', function () {
        // at least one number, one lowercase and one uppercase letter
        return {
            require: "ngModel",
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.validpassword = function (password) {
                    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;
                    return re.test(password);
                };
            }
        };
    })
    .directive('focusMe', ['$timeout', '$parse', function ($timeout, $parse) {
        return {
            //scope: true,   // optionally create a child scope
            link: function (scope, element, attrs) {
                var model = $parse(attrs.focusMe);
                scope.$watch(model, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
                // to address @blesh's comment, set attribute value to 'false'
                // on blur event:
                element.bind('blur', function () {
                    if (typeof model.assign === 'function') {
                        scope.$apply(model.assign(scope, false));
                    }
                });
            }
        };
    }])
    .directive('lessOrEqualToDate', function () {
        //Check value is equal to other model value
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=otherModelValue"
            },
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.lessOrEqualToDate = function (modelValue) {
                    var valueDate = parseDate(modelValue);
                    var otherDate = parseDate(scope.otherModelValue);
                    var result = valueDate <= otherDate;
                    if (!result)
                        element.addClass('ng-invalid-date-range');
                    else
                        element.removeClass('ng-invalid-date-range');

                    return result;
                };

                scope.$watch("otherModelValue", function () {
                    ngModel.$validate();
                }, true);
            }
        };

        function parseDate(str) {
            var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (t !== null) {
                var d = +t[1], m = +t[2], y = +t[3];
                var date = new Date(y, m - 1, d);
                if (date.getFullYear() === y && date.getMonth() === m - 1) {
                    return date;
                }
            }
            return null;
        }
    }).directive('equalOrGreaterFromDate', function () {
        //Check value is equal to other model value
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=otherModelValue"
            },
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.equalOrGreaterFromDate = function (modelValue) {
                    var valueDate = parseDate(modelValue);
                    var otherDate = parseDate(scope.otherModelValue);
                    var result = valueDate >= otherDate;
                    if (!result)
                        element.addClass('ng-invalid-date-range');
                    else
                        element.removeClass('ng-invalid-date-range');
                        
                    return result;
                };

                scope.$watch("otherModelValue", function () {
                    ngModel.$validate();
                }, true);
            }
        };

        function parseDate(str) {
            var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (t !== null) {
                var d = +t[1], m = +t[2], y = +t[3];
                var date = new Date(y, m - 1, d);
                if (date.getFullYear() === y && date.getMonth() === m - 1) {
                    return date;
                }
            }
            return null;
        }
    }).directive('convertToNull', function () {
        // at least one number, one lowercase and one uppercase letter
        return {
            require: "ngModel",
            link: function (scope, element, attributes, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return val !== 'null'? val : null;
                  });
            }
        };
    }).directive('ignoreDirty', function(){
        return{
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                void 0;                                
                ctrl.$pristine = false;
            }
        }
    });
